.<template>
    <div class="panel-full panel guestfull" v-show="isActive">
        <div class="horizFlex">
            <optionbutton :itemList="ticketTypeList_Culinary" @select="selectTicketTypeCulinary" :initialSelectedId="param1"/>
   
        </div>
        
        <div>
            <!-- dine in -->
            <div v-if="ticketType_Culinary=='Dine In'" class="innerpanelculinary leftjustified">
              <label class="">Server</label>  

              <div class="horizFlex marginbottom ">
                    
                    <!-- <linkbutton :toplabel="employee_Culinary.name" @click="selectEmployeeCulinary()"/> -->
                     <div class="employeediv">
                        <optionbutton :itemList="employeeList_Culinary" @select="selectEmployeeCulinary" :useSmallButtons="paramTrue" :initialSelectedId="employee_Culinary.id"/>
                     </div>
                    
                </div>

                <label class="">Table</label>
                <div class="horizFlex">
                    
                    <optionbutton :itemList="tableList_Culinary" @select="selectTable" :useNarrowButtons="paramTrue"/>
                </div>


            </div>

            <!-- takeout -->
            <div v-if="ticketType_Culinary=='Take Out'" class="innerpanelculinary">
                <div class="horizFlex guestentry">
                    
                    <label class="guestlabel ">Guest Name</label>
                    <input class="guestinput capital" v-model="guestName_Culinary" @change="changeGuestName"/>
                </div>
            </div>
        </div>
        

        <div v-if="pleaseWait">
          <label class="pleasewait" for>Please Wait...</label>
        </div>

   
  
      <div class="nextbutton">
        <button class="btn" @click="AddTicket_Culinary" v-show="isValid">Continue to Cart</button>
      </div>
    </div>
  </template>
  
  <script>
  import {mapFields} from 'vuex-map-fields'
  import format from '../../style/format.js'
  import dataModel from '../../store/dataModel'
  import linkbutton from '../controls/linkbutton.vue'
  import optionbutton from '../controls/optionbutton.vue'
  import entry from '../controls/entry.vue'
  import pos from '../../services/pos.js'
  import pos_culinary from '../../services/pos_culinary.js'
  export default {
    components:{
        linkbutton,
        optionbutton,
        entry
    },
    data() {
      return {
        paramTrue:true,
        param1:1,
        

      };
    },
    mixins:[dataModel,format,pos, pos_culinary],
    props: ["panelIndex"],
    computed: {
      ...mapFields([
              'panels',
              
          ]),
          
      isActive: function() {
        return this.panels[this.panelIndex].active;
      },
      isValid: function() {
        return this.panels[this.panelIndex].valid;
      },
      priorValid: function() {
        return this.panels[this.panelIndex - 1].valid;
      },
      
    },
    watch:{
      isActive:function(val){
        if(this.isActive){this.show()}
      }
    },
    methods: {
     show(){
        this.employee_Culinary={
            id:this.loggedInUser.user_personId,
            name:this.loggedInUser.name
        }
        this.getEmployeeList_Culinary()
      this.$nextTick(() => {
        
      })
     },
     
     
     
        
        
        isSelected(g){
          return g.id==this.guest.id
        },
 
        
      toNext: function() {

        var nextPanelIndex = Number(this.panelIndex) + 1;
        this.$store.dispatch('setActivePanel',nextPanelIndex); 
      },
     
    },
    mounted(){
        this.show()
    }
  };
  </script>
  
  <style scoped>
  .guestfull {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 80px auto 80px;
    grid-template-areas:
      "lookup"
      "details"
      "next";
  }
  .toggle{
    background-color: blue;
  }
  .togglehighlight{
    background-color: yellow;
  }
.innerpanelculinary{
    margin:40px;
}
.marginbottom{
    margin-bottom:30px;
}
.margintop{
    margin-top:20px;
}
.guestlabel{
    margin-right:20px;
}
.guestentry{
    width:500px;
}
.employeediv{
  max-width:90%;
  max-height:150px;
  overflow-y: auto;
  overflow-x:hidden;
}
.capital{
  text-transform: capitalize;
}
  </style>